import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { CoreModule, DestroyableComponent, formatPrice, OffersType } from '@toevla-webapplications/core';
import { TranslateModule } from '@ngx-translate/core';
import { Offer } from '../../../../services/offers/offer.model';
import { Store } from '@ngrx/store';
import { IvvaStore } from '../../../../store/store.model';
import { takeUntil } from 'rxjs';
import { User } from '../../../../services/user/user.model';
import { FavoritesService } from '../../../../services/favorites/favorites.service';

@Component({
	selector: 'ivva-offer-card',
	templateUrl: './offer-card.component.html',
	styleUrls: ['./offer-card.component.scss'],
	imports: [CoreModule, TranslateModule],
})
export class OfferCardComponent extends DestroyableComponent implements OnInit {
	@Input()
	fromFavorites: boolean = false;
	@Input()
	fromShare: boolean = false;
	@Input()
	hardcoded: 'kampas' | 'delijn' | null = null;
	@Input()
	lowerLabel: boolean = false;
	@Input()
	offer: Offer;

	isFavorite = signal(false);
	user = signal<User | null>(null);

	readonly formatPrice = formatPrice;
	readonly OffersType = OffersType;

	private readonly favoritesService = inject(FavoritesService);
	private readonly store = inject(Store<IvvaStore>);

	ngOnInit() {
		this.store
			.select('offers', 'user')
			.pipe(takeUntil(this.destroyed$))
			.subscribe((u) => this.user.set(u));

		if (!this.hardcoded) {
			this.favoritesService.favorites$.pipe(takeUntil(this.destroyed$)).subscribe((favorites) => {
				const isFavorite = favorites.find((f) => f.id === this.offer.id);
				this.isFavorite.set(!!isFavorite);
			});
		}
	}

	toggleFavorite() {
		if (this.isFavorite()) {
			this.favoritesService.remove(this.offer);
		} else {
			this.favoritesService.add(this.offer);
		}
	}
}
